import { useProfile } from '../lib/profile.jsx';
import { useIsMobile } from '../lib/useIsMobile.js';
import PageHeader from '../components/PageHeader.jsx';
import AnalystUsage from '../components/AnalystUsage.jsx';

// Owl Analyst Activity — how the client's team is using the AI analyst.
//
// A REPORT, so it lives in the Workspace nav beside App Analytics rather than in
// Settings. It shipped inside Settings first and that was wrong twice over: it sat
// behind the profile menu (two clicks nobody guesses at) and behind the
// integrations permission, which only an Owner holds — so the person most likely
// to want it, a manager wondering whether the analyst is being used, couldn't see
// it at all. Flag-gated only now, like App Analytics.
export default function AnalystActivityPage() {
  const { activeEntityId } = useProfile();
  const isMobile = useIsMobile();
  return (
    <div style={{ maxWidth: 880, margin: '0 auto', padding: isMobile ? '16px 14px 40px' : '24px 24px 56px', width: '100%' }}>
      {/* The section-page title bar every other page uses — it carries the Home
          button, and on mobile it portals into the compact menu bar instead of
          stacking a second header. `heading={false}` below stops the panel
          repeating the same title immediately underneath it. */}
      <PageHeader icon="owl" title="Owl Analyst Activity" />
      {!activeEntityId
        ? <div style={{ fontSize: 13, color: 'var(--muted)' }}>Pick a client (top-left) to see how their team is using the analyst.</div>
        : <AnalystUsage entityId={activeEntityId} scope="my" heading={false} />}
    </div>
  );
}
